import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-250 disabled:opacity-50 disabled:cursor-not-allowed rounded-button';
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary-dark shadow-button hover:shadow-card',
    secondary: 'bg-dark text-white hover:bg-dark-charcoal shadow-button hover:shadow-card',
    outline: 'bg-transparent border border-primary text-primary hover:bg-primary hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} {...props} data-id="element-267">
      {children}
    </button>;
}